export default {
      id: "icon-cizim-odasi-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-cizim-odasi",
      toString: function () {
        return this.url;
      }
    }